import {
    AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, forwardRef,
    Input, OnChanges, OnDestroy, OnInit, Output, ViewChild
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { enFormMode } from 'app/shared/enums/form-mode.enums';
import { LoadingOverlayService } from 'app/shared/services/loading-overlay.service';
import * as $ from 'jquery';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { InputBaseReactComponent } from './../input-base-react/input-base-react.component';
import { DataModel } from 'app/shared/models/DataModel';
import { FiltroCampoModel } from 'app/shared/models/FiltroCampoModel';

@Component({
    selector: 'app-input-auto-complete-react',
    templateUrl: './input-auto-complete-react.component.html',
    styleUrls: ['./input-auto-complete-react.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InputAutoCompleteReactComponent),
            multi: true
        }
    ]
})

export class InputAutoCompleteReactComponent extends InputBaseReactComponent
    implements ControlValueAccessor, OnInit, OnChanges, OnDestroy, AfterViewInit {

    @Input() nomeCampoFiltro = 'nome';
    @Input() useCache = true;
    @Input() formMode: enFormMode;
    @Input() inputObservable: Observable<any>;
    @Input() useObjectAsKey = false;
    @Input() dadosSubordinacao = false;
    @Output() outputObservable = new EventEmitter<any>();
    @Input() tipoCadastroBusca: number;
    @Input() autoCompleteVinculado: InputAutoCompleteReactComponent = undefined;
    @Input() autoCompleteDependentes: Array<InputAutoCompleteReactComponent> = undefined;
    @Input() limparDependentesOnChange = true;
    @Input() loadAllOnFocus = true;
    @ViewChild('select') select: ElementRef;
    @ViewChild('resultado') resultado: ElementRef;

    private itemSelec: DataModel = undefined;
    public searchValue: string;
    private search = new Subject<string>();
    private cacheItems: Array<DataModel>;
    private dataItems: Array<DataModel>;
    public listItems = new Array<DataModel>();
    public dadosConsulta = new FiltroCampoModel(0, 'Nome');
    private exibirLista = true;
    public focusedIndex = -1;

    constructor(
        private cdRef: ChangeDetectorRef,
        private overlayService: LoadingOverlayService
    ) {
        super();
    }

    ngOnInit(): void {
        super.ngOnInit();
        if (this.useCache || this.formMode !== enFormMode.fmInsert) {
            if (this.value) {
                this.dadosConsulta.tipoCadastro = this.tipoCadastroBusca;
                this.dadosConsulta.nomeCampoFiltro = 'Id';
                this.dadosConsulta.valorBusca = this.value;
            }
        }
    }

    ngAfterViewInit() {
        if (this.value === null || this.value === undefined || this.value === '') {
            this.value = this.form.get(this.name).value;
        }

        if (this.useCache || this.formMode !== enFormMode.fmInsert) {
            if (this.value) {
                this.dadosConsulta.tipoCadastro = this.tipoCadastroBusca;
                this.dadosConsulta.nomeCampoFiltro = 'Id';
                this.dadosConsulta.valorBusca = this.value;
            }
            this.executarBusca(this.dadosConsulta, true, (this.formMode !== enFormMode.fmInsert));
        }
        if (this.value) {
            this.control.setValue(this.value.toString());
            this.valorChange.emit(this.value);
        }
        this.setAndUpdateValidators();

        this.search.pipe(
            debounceTime(500),
            distinctUntilChanged())
            // tslint:disable-next-line: deprecation
            .subscribe(value => {
                this.dadosConsulta.valorBusca = value;
                this.executarBusca(this.dadosConsulta);
            });
    }

    ngOnChanges(): void {
        super.ngOnChanges();
        this.setAndUpdateValidators();
    }

    ngOnDestroy(): void {
        this.search.unsubscribe();
    }

    private scrollDiv() {
        $(this.resultado.nativeElement).scrollTop(20 * this.focusedIndex);
    }

    public componentKeyUp(searchValue: any): void {
        if (['ArrowDown', 'ArrowUp', 'Enter'].includes(searchValue.key)) {
            if (searchValue.key === 'ArrowUp' && this.focusedIndex > 0 && this.listItems.length > 0) {
                searchValue.preventDefault();
                this.focusedIndex--;
                this.scrollDiv();
            } else
                if (searchValue.key === 'ArrowDown' && this.focusedIndex < this.listItems.length - 1 && this.listItems.length > 0) {
                    searchValue.preventDefault();
                    this.focusedIndex++;
                    this.scrollDiv();
                } else
                    if (searchValue.key === 'Enter' && this.focusedIndex !== -1 && this.exibirLista) {
                        this.selecionarItem(this.listItems[this.focusedIndex]);
                        this.listaState(false);
                        this.focusedIndex = -1;
                    } else
                        if (searchValue.key === 'Tab') {
                            this.listaState(false);
                        }

        } else {
            if (['Control', 'Alt', 'Shift'].includes(searchValue.key)) {
                searchValue.preventDefault();
            } else {
                this.searchValue = searchValue;
                this.search.next(this.field.nativeElement.value);
                this.validarSelecionado(this.field.nativeElement.value);
                this.listaState(true);
            }
        }
    }

    public validarSelecionado(valor) {

        const listaValidacao = (this.useCache ? this.cacheItems : this.listItems);

        if (listaValidacao !== undefined) {
            const itemFound = listaValidacao.find(m => m.nome === valor);
            if (itemFound != null) {
                const dado = new DataModel();
                dado.id = itemFound.id;
                dado.nome = itemFound.nome;
                this.selectItem(dado);
            } else {
                this.itemSelec = null;
                this.value = null;
            }
        }
    }

    public validateInvalid(): boolean {
        const output = (this.itemSelec == null || this.itemSelec === undefined);

        if (output) {
            this.value = null;
            if (this.control) {
                this.control.setValue(null);
            }
        }

        return output;
    }

    protected selectItem(dado: DataModel): void {
        this.itemSelec = dado;
        this.setValue(dado);
        this.selecionarItem(dado);
    }

    protected setValue(dado: DataModel) {
        const data = (this.useObjectAsKey ? dado : dado.id);

        this.form.get(this.name).setValue(data);
        this.control.setValue(data);
        this.valorChange.emit(data);

    }

    protected verifySelectedItem(): boolean {
        return this.itemSelec !== undefined;
    }

    public getItemText(): string {
        if (this.listItems[0] !== undefined) {
            return this.listItems[0][this.nomeCampoFiltro];
        } else {
            return '';
        }
    }

    protected executarBusca(dadosConsulta: FiltroCampoModel, isOnInit: boolean = false, filterByKey = false): void {
        if ((dadosConsulta.valorBusca) && (dadosConsulta.valorBusca.length > 0) || (isOnInit)) {

            this.outputObservable.emit(dadosConsulta);

            if (this.cacheItems !== undefined && this.useCache) {
                this.listItems = this.cacheItems.filter(m => m.nome.toLowerCase().includes(dadosConsulta.valorBusca.toLowerCase()));
                this.overlayService.hide();
                this.cdRef.detectChanges();
            } else {
                if (this.inputObservable) {
                    this.inputObservable
                        // tslint:disable-next-line: deprecation
                        .subscribe(response => {
                            this.overlayService.hide();
                            dadosConsulta.tipoCadastro = this.tipoCadastroBusca;
                            dadosConsulta.valorBusca = '';

                            // tslint:disable-next-line: max-line-length
                            dadosConsulta.nomeCampoFiltro = this.nomeCampoFiltro[0].toUpperCase() + this.nomeCampoFiltro.substring(1, this.nomeCampoFiltro.length);

                            if (this.autoCompleteVinculado !== null && this.autoCompleteVinculado !== undefined) {
                                // tslint:disable-next-line: max-line-length
                                dadosConsulta.idRegistroDependente = this.autoCompleteVinculado.form.get(this.autoCompleteVinculado.name).value;
                            }

                            if (response.length > 0) {
                                this.dataItems = response.map(dado => {
                                    return {
                                        id: dado.id,
                                        nome: (dado[this.nomeCampoFiltro] === undefined ? dado.descricao : dado[this.nomeCampoFiltro]),
                                        complementar: dado
                                    } as DataModel;
                                });
                            }

                            if (this.useCache) {
                                this.cacheItems = this.dataItems;
                            }
                            // Usado para carregar dados no modo edição / detalhe
                            if (isOnInit && filterByKey) {

                                if (this.control.value) {
                                    const data = this.control.value as DataModel;
                                    if (data.id) {
                                        this.listItems =
                                            this.dataItems.filter(
                                                m => m.id.toLowerCase().includes(data.nome.toLowerCase()));
                                    } else {
                                        this.listItems =
                                            this.dataItems.filter(
                                                m => m.id.toLowerCase().includes(this.control.value.toLowerCase()));
                                    }

                                }

                                if (this.listItems.length > 0) {
                                    this.selecionarItem(this.listItems[0], filterByKey);
                                    this.field.nativeElement.value = this.listItems[0].nome;
                                } else
                                    if (this.dataItems) {
                                        if (this.dataItems.length > 0) {
                                            this.selecionarItem(this.dataItems[0], filterByKey);
                                            this.field.nativeElement.value = this.dataItems[0].nome;
                                        }
                                    }

                            } else {
                                this.listItems = this.dataItems;
                            }

                            this.cdRef.detectChanges();
                        });
                }
            }
        }
    }

    selecionarItem(dado: DataModel, filterByKey = false): void {
        const selecionado = dado.nome;

        if (this.itemSelec !== dado) {
            this.itemSelec = dado;

            this.setValue(dado);
            this.field.nativeElement.value = dado.nome;
            this.listaState(false);
            this.valorChange.emit(dado.id);

            if (this.limparDependentesOnChange && !filterByKey) {
                this.limparCamposDependentes();
            }
        }
        // this.relacaoBusca = [];
    }

    limparCamposDependentes() {
        if (this.autoCompleteDependentes !== null && this.autoCompleteDependentes !== undefined) {
            if (this.autoCompleteDependentes.length > 0) {
                for (const input of this.autoCompleteDependentes) {
                    this.form.get(input.name).setValue(null);
                    input.field.nativeElement.value = null;
                }
                this.cdRef.detectChanges();
            }
        }
    }



    exibeLista(): boolean {
        let exibeLista = this.exibirLista && !!this.listItems && this.listItems.length > 0;

        if (exibeLista) {
            if (this.field.nativeElement) {
                const exists = this.listItems.find(m => m.nome === this.field.nativeElement.value);

                exibeLista = !exists; // && this.field.nativeElement.value.length > 0;
            }
        }
        return exibeLista && this.exibirLista;
    }

    ocultarLista(): void {
        setTimeout(() => {
            this.listaState(false);
            this.cdRef.detectChanges();
        }, 500);
    }

    listaState(state: boolean) {
        this.exibirLista = state;
    }

    carregarLista(state) {
        if (this.loadAllOnFocus) {
            if (this.form.get(this.name).value === null) {
                if (this.dadosConsulta.valorBusca === null || this.dadosConsulta.valorBusca === '') {
                    this.listaState(state);
                    if (this.autoCompleteVinculado) {
                        this.dadosConsulta.idRegistroDependente =
                            this.autoCompleteVinculado.form.get(this.autoCompleteVinculado.name).value;
                    }
                    this.dadosConsulta.valorBusca = '';
                    this.dadosConsulta.tipoCadastro = this.tipoCadastroBusca;
                    this.executarBusca(this.dadosConsulta, true, false);
                }
            }
        }
    }
}
